import moment from 'moment';
import {ReplaySubject} from 'rxjs';

export class SensorHistoryRequest {
  get isLoading(): boolean {
    return this._isLoading;
  }

  set isLoading(value: boolean) {
    this._isLoading = value;
  }

  private _submitSubject = new ReplaySubject<void>(1);
  submit$ = this._submitSubject.asObservable();

  private _isLoading = false;

  // Data
  isToday: boolean;
  from: Date;
  to: Date;
  currentFilter = 2;

  constructor() {
    this.from = moment().startOf('day').toDate();
    this.to = moment().endOf('day').toDate();
    this.isToday = true;
    this.currentFilter = 2;
  }

  reset() {
    this.from = moment().startOf('day').toDate();
    this.to = moment().endOf('day').toDate();
    this.isToday = true;
    this.currentFilter = 2;
  }

  submit() {
    this._submitSubject.next();
  }
}
